export const CONFIG = {
  APP_NAME: 'Chordfy',
  APP_AUTHOR: 'by Felipe Augusto',
  APP_URL: 'https://chordfy.alistese.com.br',
  /** APK do app Android, servido de `storage/public/app` pela rota `/storage/*`. */
  MOBILE_APK_URL: '/storage/app/chordfy.apk',
};
